import React , { useState ,useEffect  , useRef }  from "react";
import { PlusIcon, MinusIcon } from "@heroicons/react/solid";
import { Link } from "react-router-dom";
import YearLineChart from 'components/ui/graph/YearLineChart';
import {number_format,APP_URL} from 'components/config/Common';
import TradingViewGaugeECharts from 'components/company/TradingViewGaugeECharts';
import ToolTipCompany from 'components/ui/ToolTipCompany';


// import the component
//import ReactSpeedometer from "react-d3-speedometer"
// and just use it

export default function RatioGraphSection({companyinfo,type, infocontent, years, values , heading}) {

  
  return (
      <section className="bg-white shadow-md z-50 rounded-xl p-4">
        <div className="flex items-center space-x-2">
        <h3 className="text-xl font-semibold">{heading}</h3>
          <ToolTipCompany 
                    content ={infocontent}
                    />
          </div>
        <YearLineChart type={type} years={years} values={values}  />
      </section> 
  );
}
